import axiosInstance from "../axiosClient";
import { uploadImage } from "../config";

export const createImage =  async(data,type) => {
  let queryParams = [];
  if (type) queryParams.push(`type=${encodeURIComponent(type)}`)
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return await axiosInstance.post(`${uploadImage}${queryString}`,data, {
    headers: {
        'Content-Type': "multipart/form-data"
    }
  });
};




